import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import axios from '../../../utils/axios';
import { BotaoAuth, CampoAuth, EntradaAuth, IconeEmail } from '../CamposAuth';

/* ============================================================================
   Primeiro passo do "esqueci minha senha": pedir o codigo por e-mail.

   Sem MUI. `POST /login/reset-password` e o tratamento de erro ficaram identicos.

   UM DEFEITO CORRIGIDO: o `catch` fazia `if (error.errors || error.message)` sem
   optional chaining. Quando a requisicao falha SEM resposta do servidor (API fora,
   rede caida, CORS), `err.response` e undefined, `error` e undefined, e a leitura
   de `error.errors` lancava um TypeError DENTRO do catch - o usuario nao via aviso
   nenhum e o erro real ficava escondido atras de "Cannot read properties of
   undefined". Agora ha uma mensagem para esse caso, que e justamente o mais comum
   numa tela usada quando algo ja nao esta funcionando.
   ============================================================================ */

export default function ResetPasswordForm({ onSent, onGetEmail }) {
  const { enqueueSnackbar } = useSnackbar();

  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string().email('E-mail invalido').required('Email é obrigatorio'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(ResetPasswordSchema),
    defaultValues: { email: '' },
  });

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(`/login/reset-password`, { email: data.email });

      if (response.status === 200 || response.status === 201) {
        enqueueSnackbar(`Recuperação de senha enviada`, { variant: 'success', style: { whiteSpace: 'pre-line' } });
        onSent();
        onGetEmail(data.email);
      }
    } catch (err) {
      const error = err?.response?.data;
      console.error(error || err);

      if (error?.errors?.length) {
        enqueueSnackbar(error.errors[0].message, { variant: 'error', style: { whiteSpace: 'pre-line' } });
      } else if (error?.message) {
        enqueueSnackbar(error.message, { variant: 'error', style: { whiteSpace: 'pre-line' } });
      } else {
        enqueueSnackbar('Não foi possível falar com o servidor. Tente novamente em instantes.', {
          variant: 'error',
          style: { whiteSpace: 'pre-line' },
        });
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-3.5" noValidate>
      <CampoAuth id="reset-email" rotulo="E-mail" erro={errors.email?.message}>
        <EntradaAuth
          id="reset-email"
          type="email"
          autoComplete="email"
          icone={<IconeEmail />}
          erro={errors.email}
          placeholder="seu.email@empresa.com.br"
          {...register('email')}
        />
      </CampoAuth>

      <BotaoAuth carregando={isSubmitting}>Enviar código</BotaoAuth>
    </form>
  );
}
